module.exports = __webpack_public_path__ + "static/img/deeplearning.70cf2cca.png";